module.exports = __webpack_public_path__ + "img/our3.6eb40498.svg";